<template>
  <a-spin :spinning="loading">
    <div class="example-table">
      <div class="notice">
        <p>{{ $t('seller.productTable.csvBulkNoticeP1') }}</p>
        <p>{{ $t('seller.productTable.csvBulkNoticeP2') }}</p>
        <p>{{ $t('seller.productTable.csvBulkNoticeP3') }}</p>
      </div>
      <div class="down-example">
        <artmisads-select-button @click="exportDownloadProductTemplate">
          <svg class="icon icon-daochu1" aria-hidden="true">
            <use xlink:href="#icon-daochu1"></use>
          </svg>
          {{ $t('seller.productTable.downloadTemplateBtn') }}
        </artmisads-select-button>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="table">
            <artmisads-table
              :columns="columns"
              row-key="id"
              :data-source="exampleDataList"
              :pagination="false"
              :bordered="true"
            >
              <template #bodyCell="{ column, record }">
                <template
                  v-if="
                    column.name === 'status' &&
                    (record.status === 'inactive' || record.status === 'active')
                  "
                >
                  {{
                    record.status === 'inactive'
                      ? $t('seller.common.inactive')
                      : $t('seller.common.active')
                  }}
                  <!-- <showStatus :isActive="record.status === 'active'" :noBorder="true"/> -->
                </template>
              </template>
            </artmisads-table>
          </div>
          <div class="file-name" v-if="fileName">
            <div>
              <svg class="icon icon-biaoge" aria-hidden="true">
                <use xlink:href="#icon-biaoge"></use>
              </svg>
              <span class="name">{{ fileName }}</span>
              <svg class="icon close-cu" aria-hidden="true" @click="clearFile">
                <use xlink:href="#icon-close-cu"></use>
              </svg>
            </div>
          </div>
          <a-upload
            name="avatar"
            list-type="picture-card"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleChange"
            v-else
          >
            <p class="ant-upload-drag-icon">
              <inbox-outlined></inbox-outlined>
            </p>
            <svg class="icon shangchuan2" aria-hidden="true">
              <use xlink:href="#icon-jiahao-cu"></use>
            </svg>
            {{ $t('seller.productTable.chooseFileHint') }}
          </a-upload>
        </div>
        <div class="content-right">
          <div class="description">
            <span class="line"></span>
            <span class="text">{{
              $t('seller.productTable.csvLegendDescription')
            }}</span>
          </div>
          <div class="required">
            <span class="line"></span>
            <span class="text">{{
              $t('seller.productTable.csvLegendRequired')
            }}</span>
          </div>
          <div class="example">
            <span class="line"></span>
            <span class="text">{{
              $t('seller.productTable.csvLegendExample')
            }}</span>
          </div>
        </div>
      </div>
      <div class="next-btn">
        <artmisads-button
          type="primary"
          @click="toNext"
          v-if="dataList.failList.length || dataList.successList.length"
        >
          {{ $t('seller.productTable.csvNext') }}
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-jiantou-you-cu"></use>
          </svg>
        </artmisads-button>
        <artmisads-button type="primary" v-else disabled>{{
          $t('seller.productTable.csvNext')
        }}</artmisads-button>
      </div>
    </div>
  </a-spin>
</template>
<script setup>
import { message } from 'ant-design-vue'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { productsApi } from '../../../../server/index'

const { t, locale } = useI18n()
const fileName = ref('')
const loading = ref(false)
const props = defineProps([
  'setDataList',
  'setShowExample',
  'dataList',
  'activeTab',
])

const clearFile = () => {
  fileName.value = ''
  props.setDataList({ successList: [], failList: [] })
}

const exampleDataList = computed(() => [
  {
    id: 1,
    asin: t('seller.productTable.csvExampleAsinDesc'),
    amazonSellerAccount: t('seller.productTable.csvExampleSellerDesc'),
    commission: t('seller.productTable.csvExampleCommissionDesc'),
    status: t('seller.productTable.csvExampleStatusDesc'),
  },
  {
    id: 2,
    asin: t('seller.productTable.csvExampleYes'),
    amazonSellerAccount: t('seller.productTable.csvExampleYes'),
    commission: t('seller.productTable.csvExampleNo'),
    status: t('seller.productTable.csvExampleNo'),
  },
  {
    id: 3,
    asin: 'B08QRFZ5VV',
    amazonSellerAccount: t('seller.productTable.csvExampleSellerPlaceholder'),
    commission: '20%',
    status: 'active',
  },
  {
    id: 4,
    asin: 'B05QRFZ8VV',
    amazonSellerAccount: t('seller.productTable.csvExampleSellerPlaceholder'),
    commission: '20%',
    status: 'active',
  },
  {
    id: 5,
    asin: 'B07HHGS22J',
    amazonSellerAccount: t('seller.productTable.csvExampleSellerPlaceholder'),
    commission: '15%',
    status: 'active',
  },
  {
    id: 6,
    asin: 'B09JKDAWU1',
    amazonSellerAccount: t('seller.productTable.csvExampleSellerPlaceholder'),
    commission: '20%',
    status: 'active',
  },
])

const buildColumns = () => {
  if (props.activeTab === '0') {
    return [
      {
        title: t('seller.brandsPage.colAsin'),
        dataIndex: 'asin',
        width: '17%',
      },
      {
        title: t('seller.productTable.colAmazonSellerName'),
        dataIndex: 'amazonSellerAccount',
        width: '39%',
      },
      {
        title: t('seller.productTable.colCommission'),
        dataIndex: 'commission',
        width: '19%',
      },
      {
        title: t('seller.productTable.colStatus'),
        dataIndex: 'status',
        name: 'status',
        width: '25%',
      },
    ]
  }
  return [
    {
      title: t('seller.brandsPage.colAsin'),
      dataIndex: 'asin',
      width: '17%',
    },
    {
      title: t('seller.productTable.colAmazonSellerName'),
      dataIndex: 'amazonSellerAccount',
      width: '39%',
    },
    {
      title: t('seller.productTable.colAssociateStatus'),
      dataIndex: 'status',
      name: 'status',
      width: '25%',
    },
  ]
}

const columns = ref([])
watch(
  () => [props.activeTab, locale.value],
  () => {
    columns.value = buildColumns()
  },
  { immediate: true },
)
const exportDownloadProductTemplate = () => {
  const finalParams = {
    qs: {},
    fileName: t('seller.productTable.csvTemplateFileName'),
  }
  if (props.activeTab == '0') {
    productsApi.exportDownloadProductTemplate(finalParams)
  } else {
    productsApi.downloadAssociateProduct(finalParams)
  }
}

const handleChange = async ({ file }) => {
  const { type, originFileObj, percent, name } = file
  let form = new FormData()
  form.append('file', originFileObj)
  if (percent === 100) {
    if (type !== 'text/csv') {
      return message.error(t('seller.msg.uploadCsvOnly'))
    } else {
      loading.value = true
      let res
      if (props.activeTab === '1') {
        res = await productsApi.preAssociateCommissionCsv(form)
      } else {
        res = await productsApi.preCommissionCsv(form)
      }
      const { success, error, data } = res
      if (success) {
        const successList = data.successList || []
        const failList = data.failList || []
        if (!successList.length && !failList.length) {
          message.warning(t('seller.msg.noMatchingData'))
        } else {
          message.success(t('seller.msg.success'))
          const dataList = { successList, failList }
          props.setDataList(dataList)
          fileName.value = name
        }
      }
      loading.value = false
    }
  }
}

const toNext = () => {
  props.setShowExample(false)
}
</script>

<style lang="less" scoped>
.example-table {
  .notice {
    padding-right: 160px;
    > p {
      letter-spacing: 0.4px;
      line-height: 20px;
      color: var(--dark-2);
      padding-top: 8px;
      &:last-child {
        padding-top: 10px;
      }
    }
  }

  .content {
    padding: 12px 0 24px;
    display: flex;
    :deep(.ant-table-wrapper) {
      .ant-table-cell {
        padding: 8px;
        line-height: 20px;
        word-break: break-word;
        border-color: var(--border-4) !important;
      }
      .ant-table-thead {
        .ant-table-cell {
          border-bottom-color: var(--border-1) !important;
        }
      }
      .ant-table-container {
        border-color: var(--border-4) !important;
      }
      table {
        border-top: none !important;
        border-color: var(--border-4) !important;
      }
    }
  }
  .content-right {
    margin-left: 8px;
    margin-top: 40px;
    .description,
    .required,
    .example {
      display: flex;
      .line {
        width: 2px;
        height: 100%;
      }
      .text {
        font-weight: 500;
        line-height: 20px;
        padding-left: 8px;
        padding-right: 8px;
        height: 20px;
        align-self: center;
        border-radius: 4px;
        margin-left: 16px;
      }
    }
    .description {
      height: 112px;
      .line {
        background-color: var(--primary-bg);
      }
      .text {
        color: var(--primary-text);
        background-color: var(--table-cell-bg-3);
        border: 1px solid var(--primary-border-3);
      }
    }
    .required {
      height: 34px;
      margin-top: 4px;
      .line {
        background-color: var(--yellow-5);
      }
      .text {
        color: var(--yellow-4);
        background-color: var(--table-cell-bg-2);
        border: 1px solid var(--yellow-5);
      }
    }
    .example {
      height: 144px;
      margin-top: 4px;
      .line {
        background-color: var(--green-4);
      }
      .text {
        color: var(--green-1);
        background-color: var(--table-cell-bg-1);
        border: 1px solid var(--green-2);
      }
    }
  }
  .table {
    width: 1020px;
  }
  .down-example {
    margin-top: 12px;
    button {
      display: flex;
      svg {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        align-self: center;
      }
    }
  }
  .content-left {
    .file-name {
      display: flex;
      width: 100%;
      height: 60px;
      cursor: pointer;
      background: var(--big-bg-1);
      border-radius: 8px;
      color: var(--dark-2);
      margin-top: 8px;
      &:hover {
        background: var(--bg-gray-2);
      }
      > div {
        display: flex;
        height: 28px;
        padding: 0 24px;
        border-radius: 8px;
        align-self: center;
        // &:hover {
        //   background-color: var(--bg-gray-4);
        // }
        .icon-biaoge {
          width: 24px;
          height: 24px;
          fill: var(--primary-text);
          align-self: center;
        }
        .name {
          color: var(--primary-text);
          font-weight: 500;
          font-size: 16px;
          letter-spacing: 0.4px;
          line-height: 22px;
          margin-left: 8px;
          margin-right: 24px;
          align-self: center;
        }
        .close-cu {
          cursor: pointer;
          width: 24px;
          height: 24px;
          padding: 4px;
          align-self: center;
          fill: var(--dark-3);
          &:hover {
            fill: var(--dark-1);
          }
        }
      }
    }
    :deep(.ant-upload-wrapper) {
      margin-top: 16px;
      .ant-upload.ant-upload-select {
        width: 100%;
        height: 60px;
        color: var(--dark-2);
        background: var(--big-bg-1);
        border: 1px dashed var(--border-1);
        border-radius: 8px;
        font-size: var(--font-size-h-l);
        font-weight: 500;
        &:hover {
          background: var(--bg-gray-2);
          border: 1px dashed var(--bg-gray-7);
        }
        svg {
          width: 24px;
          height: 24px;
          fill: var(--dark-2);
          margin-right: 8px;
        }
      }
    }
  }
  .next-btn {
    border-top: 1px solid var(--border-4);
    padding: 10px 0 0 0;
    display: flex;
    justify-content: right;
    // > button {
    //   border: 2px solid var(--primary);
    //   box-shadow: var(--section-box-shadow-2);
    //   background-color: var(--color-white) !important;
    //   color: var(--primary);
    //   svg {
    //     fill: var(--primary);
    //     margin-left: 8px;
    //   }
    // }
  }
}
</style>
